const showcaseCoverage = [
	{
		path: '/community/showcase-coverage',
		name: 'community-showcase-coverage',
		component: () => import('@/views/community/showcase-coverage/index.vue'),
		meta: { layout: 'content', module: 'MGC,community' },
	},
]

export default showcaseCoverage
